import React, { useRef } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import { useStore, loginActions } from '@modules';

import Input from '@components/Input';
import { useLoginContext } from '@containers/App/routes/login/LoginContext';

import style from './Email.scss';

const cn = bemCssModules(style, 'Email');
const ti = getTestId('Email');

export type TEmail = {
  email: string;
  isLoading: boolean;
};

export const Email: CustomFC<TEmail> = ({ className, email, isLoading }) => {
  const { t } = useTranslation();

  const [{ login }, dispatch] = useStore();
  const { errors } = login;

  const inputRef = useRef<HTMLInputElement>(null);
  const [, setContext] = useLoginContext();
  const validationErrors = errors?.data;

  const handleChangeEmail = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (validationErrors?.email?.length) dispatch(loginActions.clearErrors());
    setContext('email', event.target.value);
  };

  return (
    <div className={cn(null, [className])} data-testid={ti()}>
      <Input
        label={t('settings.email')}
        isLoading={isLoading}
        error={validationErrors?.phone?.join('\n')}
        ref={inputRef}
        name="email"
        className={cn('input')}
        type="email"
        autoFocus
        inputMode="email"
        placeholder="mercuryo@mercuryo.io"
        value={email}
        onChange={handleChangeEmail}
        autoComplete="email"
      />
    </div>
  );
};

export default Email;
